<template>
  <div class="cart profile addProduct">
    <div class="card">
      <div class="card-body">
        <form class="form row" @keydown.enter.prevent>
          <div class="col-md-6">
            <!-- Название -->
            <div class="input">
              <label for="name">Название продукта</label>
              <input
                v-model="formData.name"
                type="text"
                class="form-control mt-2"
                id="name"
                placeholder="Введите название"
                required
              />
            </div>
            <!-- Описание -->
            <div class="input mt-3">
              <label for="description">Описание</label>
              <textarea
                v-model="formData.description"
                type="text"
                class="form-control mt-2"
                rows="5"
                id="description"
                placeholder="Введите описание"
                required
              />
            </div>
            <!-- Фото -->
            <div class="input images mt-3">
              <label for="inputGroupFile01">Фото товара</label>
              <input
                ref="fileInput"
                @change="onFileChange($event)"
                type="file"
                class="form-control d-none"
                style="height: fit-content"
                id="inputGroupFile01"
                multiple
                :disabled="productImages?.length >= 7"
              />
              <div
                class="selectImage mt-2"
                v-if="productImages?.length < 8"
                @click="triggerFileUpload"
              >
                <img src="@/assets/images/icons/image.png" />
              </div>
              <div class="images-selected mt-4" v-if="productImages?.length">
                <div
                  class="images-selected__block"
                  v-for="(item, index) in productImages"
                  :key="index"
                >
                  <img
                    class="close"
                    src="@/assets/images/icons/close.svg"
                    @click="deleteImg(index)"
                  />
                  <img
                    :src="item.image ? item.image : item"
                    width="100"
                    height="100"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="input-row" v-if="formData.product_type !== 'service'">
              <label for="flexSwitchCheckDefault">В наличии</label>
              <input
                v-model="formData.in_stock"
                type="checkbox"
                class="ms-2"
                role="switch"
                id="flexSwitchCheckDefault"
                placeholder=""
              />
            </div>
            <div class="input-row mt-3">
              <label for="flexSwitchCheckDefault">Цена включает налоги</label>
              <input
                v-model="formData.price_with_taxes"
                type="checkbox"
                class="ms-2"
                role="switch"
                id="flexSwitchCheckDefault"
                placeholder=""
              />
            </div>
            <!-- Теги -->
            <div class="input tags mt-3">
              <label for="tags">Теги</label>
              <div class="tag-input">
                <div class="tags-container">
                  <span
                    v-for="(tag, index) in formTags"
                    :key="index"
                    class="tag"
                  >
                    {{ tag.name || tag }}
                    <button
                      type="button"
                      class="remove-tag"
                      @click="removeTag(index)"
                    >
                      &times;
                    </button>
                  </span>
                  <input
                    type="text"
                    class="form-control mt-2"
                    v-model="newTag"
                    @keyup.enter="addTag"
                    placeholder="Добавьте тег и нажмите Enter"
                  /><small class="form-text text-muted mt-1">
                    Нажмите <b>Enter</b>, чтобы добавить тег
                  </small>
                </div>
              </div>
            </div>
            <!-- Тип продукта -->
            <div class="input mt-3">
              <label for="floatingSelect">Тип продукта</label>
              <select
                v-model="formData.product_type"
                class="form-select mt-2"
                id="floatingSelect"
                required
              >
                <option value="product">Товар</option>
                <option value="service">Услуга</option>
              </select>
            </div>
            <!-- Категория -->
            <div class="input mt-3" v-if="productCategories?.length">
              <label for="floatingSelect">Категория</label>
              <div class="dropdown-wrapper">
                <div class="dropdown-selected" @click="toggleCategoryDropdown">
                  {{
                    getCategoryName(formData.category) || "Выберите категорию"
                  }}
                </div>
                <div
                  v-if="showCategoryDropdown"
                  class="dropdown-panel bg-white border rounded p-3 mt-1"
                >
                  <div>
                    <div
                      v-for="cat in productCategories"
                      :key="cat.id"
                      class="mb-1"
                    >
                      <div
                        class="cursor-pointer hover:underline"
                        @click="selectCategory(cat.id)"
                      >
                        {{ cat.name }}
                      </div>
                      <div v-if="cat.childrens?.length" class="ml-4">
                        <div
                          v-for="sub in cat.childrens"
                          :key="sub.id"
                          class="mb-1"
                        >
                          <div
                            class="cursor-pointer hover:underline"
                            @click="selectCategory(sub.id)"
                          >
                            {{ sub.name }}
                          </div>
                          <div v-if="sub.childrens?.length" class="ml-4">
                            <div v-for="sub2 in sub.childrens" :key="sub2.id">
                              <div
                                class="cursor-pointer hover:underline"
                                @click="selectCategory(sub2.id)"
                              >
                                {{ sub2.name }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Компания -->
            <div class="input mt-3">
              <label for="floatingSelect">Компания</label>
              <select
                v-model="formData.company"
                class="form-select mt-2"
                id="floatingSelect"
                @change="onCompanyChange"
              >
                <option disabled value="">Выберите компанию</option>
                <option
                  v-for="(item, index) in productCompanies"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.id }} {{ item.name_full }}
                </option>
              </select>
            </div>
            <!-- ИП -->
            <div class="input mt-3">
              <label for="floatingSelect">ИП</label>
              <select
                v-model="formData.entrepreneur"
                class="form-select mt-2"
                id="floatingSelect"
                @change="onEntrepreneurChange"
              >
                <option disabled value="">Выберите ИП</option>
                <option
                  v-for="(item, index) in productEntrepreneurCompanies"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.id }} {{ item.fio }}
                </option>
              </select>
            </div>

            <!-- <div class="input mt-3">
              <label for="code">Код продукта</label>
              <input
                v-model="formData.product_code"
                type="text"
                class="form-control mt-2"
                id="code"
                placeholder="Введите код"
              />
            </div> -->
            <!-- <div class="input mt-3">
              <label for="sku">SKU продукта</label>
              <input
                v-model="formData.sku_article"
                type="text"
                class="form-control mt-2"
                id="sku"
                placeholder="Введите SKU"
                required
              />
            </div> -->
            <div class="input mt-3">
              <label for="price">Стоимость</label>
              <input
                v-model="formData.price"
                type="number"
                class="form-control mt-2"
                id="price"
                placeholder="Введите стоимость"
                :max="1000000000"
                required
              />
            </div>
            <!-- Цена со скидкой -->
            <!-- <div class="input mt-3">
              <label for="salePrice"
                >Цена со скидкой <span>(необязательно)</span></label
              >
              <input
                v-model="formData.sale_price"
                type="number"
                class="form-control mt-2"
                id="salePrice"
                placeholder="Введите цену со скидкой"
                :max="1000000000"
                required
              />
            </div> -->
            <!-- Код продукта -->
            <div class="input mt-3">
              <label for="code">Код продукта</label>
              <input
                v-model="formData.product_code"
                type="number"
                class="form-control mt-2"
                id="product_code"
                placeholder="Введите код продукта"
                required
              />
            </div>
            <!-- Артикул -->
            <!-- <div class="input mt-3">
              <label for="sku">Артикул</label>
              <input
                v-model="formData.sku_article"
                type="number"
                class="form-control mt-2"
                id="sku_article"
                placeholder="Введите артикул продукта"
                required
              />
            </div> -->
            <!-- Ошибки -->
            <div class="error" role="alert">{{ error }}</div>
            <!-- Кнопка -->
            <button class="black-button mt-4" @click.prevent="addProduct">
              Разместить
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import MarketplaceService from "@/services/marketplace";
import CompanyService from "@/services/company";
import productCategoriesService from "@/services/products";

const router = useRouter();
const store = useStore();
const loggedIn = computed(() => store.state.auth.status.loggedIn);
const currentUser = ref({});
const productCategories = ref([]);
const productCompanies = ref([]);
const productEntrepreneurCompanies = ref([]);
// const productTags = ref([]);
// const productTagsWithIds = ref([]);
const fileInput = ref(null);
const error = ref(null);
const route = useRoute();

const showCategoryDropdown = ref(false);

const formData = ref({
  category: "",
  company: "",
  entrepreneur: "",
});
// const formImages = ref([]);
const formTags = ref([]);
const productImages = ref([]);
const newTag = ref("");

onMounted(async () => {
  if (!loggedIn.value) {
    router.push("/");
  } else {
    const user = await store.dispatch("user/me");
    currentUser.value = user;
    // if (!currentUser.value.membership_exists) {
    //   router.push("/plans");
    // }

    CompanyService.getCompany(user.id).then((res) => {
      productCompanies.value = res.result;
    });

    CompanyService.getEntrepreneur(user.id).then((res) => {
      productEntrepreneurCompanies.value = res.result;
    });

    productCategoriesService.all().then((res) => {
      productCategories.value = res;
    });
    if (route.params.id) {
      MarketplaceService.show(route.params.id).then((res) => {
        formData.value.name = res.name;
        formData.value.company = res.company;
        formData.value.entrepreneur = res.entrepreneur;
        formData.value.description = res.description;
        formData.value.category = res.category.id;
        formData.value.product_type = res.product_type;
        // formData.value.sku_article = res.sku_article;
        formData.value.product_code = res.product_code;
        formData.value.in_stock = res.in_stock;
        formData.value.price_with_taxes = res.price_with_taxes;
        formData.value.price = parseFloat(
          res.price.toString().replace(",", ".")
        );
        // formData.value.sale_price = parseFloat(
        //   res.sale_price.toString().replace(",", ".")
        // );
        // formData.value.sku_article = res.sku_article;
        // formData.value.product_code = res.product_code;
        formTags.value = res.tags;
        productImages.value = res.images;
      });
    }
  }
});

// NEW: взаимоисключающий выбор «Компания/ИП»
const onCompanyChange = () => {
  if (formData.value.company) {
    formData.value.entrepreneur = ""; // сбрасываем ИП
  }
};
const onEntrepreneurChange = () => {
  if (formData.value.entrepreneur) {
    formData.value.company = ""; // сбрасываем Компанию
  }
};

const triggerFileUpload = () => {
  fileInput.value.click();
};
const onFileChange = (event) => {
  if (event.target.files && event.target.files[0]) {
    const images = event.target.files;
    Array.from(images).forEach((item) => {
      productImages.value.push({
        image: URL.createObjectURL(item),
        file: item,
      });
    });
  }
};

const deleteImg = async (index) => {
  // console.log("deleteImg", index);
  // await MarketplaceService.deleteImage(productImages.value[index].id);
  // productImages.value.splice(index, 1);
  // fileInput.value.value = null;

  const image = productImages.value[index];

  // Если у картинки есть id — это загруженное изображение с бэка
  if (image.id) {
    try {
      await MarketplaceService.deleteImage(image.id);
    } catch (e) {
      console.warn("Ошибка при удалении изображения:", e);
    }
  }

  // В любом случае удаляем из массива
  productImages.value.splice(index, 1);
  fileInput.value.value = null;
};

const getImagesFromFormData = (formData) => {
  const images = [];
  for (let [key, value] of formData.entries()) {
    if (key === "images") {
      images.push(value);
    }
  }
  return images;
};

const addTag = () => {
  const trimmedTag = newTag.value.trim();
  if (trimmedTag && !formTags.value.includes(trimmedTag)) {
    formTags.value.push(trimmedTag);
    newTag.value = "";
  }
};
// Удаление тега
const removeTag = (index) => {
  formTags.value.splice(index, 1);
};

// Dropdown категории
const toggleCategoryDropdown = () => {
  showCategoryDropdown.value = !showCategoryDropdown.value;
};
const selectCategory = (id) => {
  formData.value.category = id;
  showCategoryDropdown.value = false;
};
const getCategoryName = (id) => {
  const findRec = (arr) => {
    for (const cat of arr) {
      if (cat.id === id) return cat.name;
      if (cat.childrens) {
        const res = findRec(cat.childrens);
        if (res) return res;
      }
    }
    return null;
  };
  return findRec(productCategories.value);
};

const addProduct = async () => {
  const entries = Object.entries(formData.value);
  const newProduct = new FormData();

  // Добавляем текстовые данные в FormData
  entries.forEach(([key, value]) => {
    if (key === "in_stock") {
      newProduct.append("in_stock", value ? 1 : 0);
      return;
    }
    if (key === "price_with_taxes") {
      newProduct.append("price_with_taxes", value ? 1 : 0);
      return;
    }
    if (key === "entrepreneur" && value === null) {
      newProduct.append("entrepreneur", "");
      return;
    }
    if (key === "company" && value === null) {
      newProduct.append("company", "");
      return;
    }
    newProduct.append(key, value);
  });
  // Добавляем теги
  for (const item of formTags.value) {
    if (!item.id) {
      const data = {
        name: item,
      };
      await productCategoriesService.addTags(data).then((res) => {
        newProduct.append("tags", res.id);
      });
    } else {
      newProduct.append("tags", item.id);
    }
  }

  // Асинхронно обрабатываем изображения
  for (const item of productImages.value) {
    if (item.file) {
      newProduct.append("images", item.file);
    }
  }

  // Проверка всех обязательных полей

  if (
    formData.value.name &&
    (formData.value.company || formData.value.entrepreneur) &&
    formData.value.description &&
    formData.value.category &&
    formData.value.price &&
    formData.value.product_type &&
    // formData.value.sku_article &&
    formData.value.product_code &&
    formTags.value &&
    productImages.value.length >= 1
  ) {
    try {
      if (route.params.id) {
        const imgFormData = new FormData();
        const images = getImagesFromFormData(newProduct);
        images.forEach((image, index) => {
          imgFormData.append(`images`, image);
        });
        await MarketplaceService.update(route.params.id, newProduct);
        if (images.length) {
          await MarketplaceService.addImage(route.params.id, imgFormData);
        }
      } else {
        // Создание нового продукта
        await MarketplaceService.add(newProduct);
      }
      router.push("/profile/products");
    } catch (e) {
      error.value = "Ошибка при сохранении данных";
    }
  } else {
    error.value = "Заполните все поля";
  }
};
</script>

<style scoped lang="scss">
label span {
  color: #a1a1a1;
}
.selectImage {
  background-color: #f7f7f7;
  width: 100px;
  height: 100px;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  text-align: center;
  display: flex;
  cursor: pointer;
}
.images {
  &-selected {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    &__block {
      position: relative;

      .close {
        position: absolute;
        right: 0.5rem;
        top: 0.5rem;
        cursor: pointer;
      }
    }
  }
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.tag {
  background-color: #f0f0f0;
  padding: 5px 10px;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

.remove-tag {
  background: none;
  border: none;
  font-size: 14px;
  cursor: pointer;
  margin-left: 5px;
}

.form-control {
  border: 1px solid #ccc;
  padding: 5px 10px;
  border-radius: 5px;
  min-width: 150px;
}

.dropdown-wrapper {
  position: relative;
}

.dropdown-selected {
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  background: #fff;
}

.dropdown-panel {
  position: absolute;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  z-index: 20;
}
</style>
